import { SET_FEATURE_FLAG, GENERAL_SETTINGS } from '../constants';

const initialState = {
  useScanpackScanningV2: false,
  wmsInventoryEnabled: false
};

const featuresReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FEATURE_FLAG:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    case GENERAL_SETTINGS: {
      const useScanpackScanningV2 =
        action.payload?.data?.use_scanpack_scanning_v2;
      // wms_inventory_enabled is a top-level tenant boolean on the
      // get_settings response (like use_scanpack_scanning_v2), NOT nested
      // under data.general_setting. Defaults to false when absent.
      const wmsInventoryEnabled = action.payload?.data?.wms_inventory_enabled;

      if (useScanpackScanningV2 === undefined && wmsInventoryEnabled === undefined) {
        return state;
      }

      return {
        ...state,
        ...(useScanpackScanningV2 !== undefined && {
          useScanpackScanningV2: !!useScanpackScanningV2
        }),
        wmsInventoryEnabled: !!wmsInventoryEnabled
      };
    }
    default:
      return state;
  }
};

export default featuresReducer;
